<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="element">
          <div class="search-box-container">
            <div class="nav" style="border-radius: 8px 8px 0 0">
              <h1>
                Vídeos
                <span v-if="!listLoading && !listError">({{ videoCount }})</span>
              </h1>
              <select
                class="form-select"
                @change="selectNewStatus($event)"
                :disabled="listLoading"
              >
                <option value="">Todos</option>
                <option value="2">Ativos</option>
                <option value="3">Desativados</option>
              </select>
            </div>
          </div>
          <div class="project-list">
            <div
              class="post_project post_project-active"
              style="padding: 20px; height: auto"
              :class="{ nopro: videos && videos.length === 0 }"
            >
              <div class="loading_container" v-if="listLoading" style="height: 200px">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
              <div v-else-if="listError" class="create-project">
                <div class="card">
                  <div class="card-body">
                    <h2 class="text-danger">Erro</h2>
                    <p class="text-danger">
                      Ocorreu um erro ao atualizar a lista de vídeos.<br />
                      Por favor, tente novamente.
                    </p>
                  </div>
                </div>
              </div>
              <div class="create-project" v-else-if="!videos || videos.length === 0">
                <div class="card">
                  <img src="assets/img/project.png" alt="" />
                  <div class="card-body">
                    <h2>Nenhum vídeo encontrado</h2>
                  </div>
                </div>
              </div>
              <div class="active-project" style="padding: 0" v-else>
                <a
                  class="card"
                  style="position: static"
                  v-for="video in videos"
                  :key="video.id"
                  :href="'/video/' + video.id"
                >
                  <div class="name">
                    <p>
                      Título <br />
                      <span>{{ video.title }}</span>
                    </p>
                  </div>
                  <div class="date">
                    <p>
                      Data de registro <br />
                      <span>{{ formatTimestamp(video.registration_timestamp) }}</span>
                    </p>
                  </div>
                  <div class="count">
                    <p>
                      Comentários <br />
                      <span>{{ video.total_comments }}</span>
                    </p>
                  </div>
                  <div class="status">
                    <p>
                      Status <br />
                      <span :class="getTextStatusClass(video.status)">
                        {{ formatProjectStatus(video.status) }}</span
                      >
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button class="btn mt-3" @click="addVideo()">Adicionar aula/mentoria</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AdminManager from "../../../js/services/admin.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "VideoListPage");
    this.loadClients();
  },

  data() {
    return {
      videos: null,
      listLoading: false,
      listError: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },

    videoCount() {
      if (this.videos) {
        return this.videos.length;
      }
      return 0;
    },
  },

  methods: {
    async loadClients() {
      this.$store.commit("setLoading", true);
      try {
        let response = await AdminManager.getVideos();
        let profile = response.profile;
        this.videos = response.videos;
        this.$store.commit("setActiveUser", profile);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.handleAPIError(error, this.$route.fullPath.replace(/^\/+/, ""));
      }
    },

    async selectNewStatus(event) {
      let selectedStatus = event.target.value;
      this.listLoading = true;
      this.listError = null;
      try {
        let response = await AdminManager.getVideos(selectedStatus);
        this.videos = response.videos;
      } catch (err) {
        console.log(err);
        this.listError = err;
      } finally {
        this.listLoading = false;
      }
    },

    async addVideo() {
      let $ctx = this;
      let $modal = $("#editVideoModal");
      $modal.find(".modal-title").text("Adicionar aula/mentoria");
      $modal.find(".item").removeClass("error");

      let action = async function () {
        let linksStr = $modal.find("[data-video-links]").val().split("\n");
        let links = [];

        let videoDetails = {
          type: $modal.find("[data-video-type]").val(),
          title: $modal.find("[data-video-title]").val(),
          course_id: $modal.find("[data-video-course-id]").val(),
          description: $modal.find("[data-video-description]").val(),
          path: $modal.find("[data-video-path]").val(),
          video_file: $modal.find("[data-video-file]").val(),
          links: links,
          release_threshold: null,
          status: $modal.find("[data-video-status]").val(),
        };

        let hasError = false;
        $modal.find(".item").removeClass("error");

        if (videoDetails.title.length < 10) {
          $modal.find("[data-video-title]").closest(".item").addClass("error");
          hasError = true;
        }
        if (videoDetails.path.length < 10) {
          $modal.find("[data-video-path]").closest(".item").addClass("error");
          hasError = true;
        }
        if (videoDetails.type === "2" || videoDetails.type === "4") {
          if (videoDetails.video_file.length < 10) {
            $modal.find("[data-video-file]").closest(".item").addClass("error");
            hasError = true;
          }
        }
        if (videoDetails.description.length < 50) {
          $modal.find("[data-video-description]").closest(".item").addClass("error");
          hasError = true;
        }
        if (linksStr && linksStr.length > 0) {
          let linkError = false;
          linksStr.forEach((l) => {
            if (!l || l.trim().length === 0) {
              return;
            }
            let link = l.split("|");
            if (!l || link.length !== 2) {
              linkError = true;
            } else {
              let url = link[0].trim();
              let title = link[1].trim();

              if (!url.startsWith("https://") || url.length < 20 || title.length < 3) {
                linkError = true;
              } else {
                links.push({
                  src: url,
                  title: title,
                });
              }
            }

            if (linkError) {
              $modal
                .find("[data-video-links]")
                .closest(".item")
                .addClass("error")
                .find("em")
                .text(
                  "O link >>>" +
                    l +
                    "<<< é inválido. Formato: https://link.com|titulo do link"
                );
              hasError = true;
            }
          });
        }

        if (videoDetails.type === "3") {
          const { DateTime } = luxon;
          const dt = DateTime.fromFormat(
            $modal.find("[data-live-release]").val(),
            "yyyy-MM-dd HH:mm:ss",
            {
              zone: "America/Sao_Paulo",
              setZone: true,
            }
          );

          if (!dt.isValid) {
            $modal.find("[data-live-release]").closest(".item").addClass("error");
            hasError = true;
          }
          videoDetails.release_threshold = dt.toJSDate().getTime();
          videoDetails.meetup_link = $modal.find("[data-meet-link]").val();

          if (
            !videoDetails.meetup_link.startsWith("https://") ||
            videoDetails.meetup_link.length < 20
          ) {
            $modal.find("[data-meet-link]").closest(".item").addClass("error");
            hasError = true;
          }
        } else {
          if ($modal.find("[data-video-release]").val()) {
            videoDetails.release_threshold =
              Number($modal.find("[data-video-release]").val()) * 24 * 3600 * 1000;
          }
        }

        if (hasError) {
          return false;
        }

        let updatedVideo = await AdminManager.addVideo(videoDetails);
        updatedVideo.total_comments = 0;

        $ctx.videos.unshift(updatedVideo);
        return true;
      };

      $modal.find("[data-video-type]").val("1");
      $modal.find("[data-video-title]").val("");
      $modal.find("[data-video-course-id]").val("form-av");
      $modal.find("[data-video-description]").val("");
      $modal.find("[data-meet-link]").val("");
      $modal.find("[data-video-path]").val("");
      $modal.find("[data-video-file]").val("");
      $modal.find("[data-video-links]").val("");
      $modal.find("[data-video-release]").val("");
      $modal.find("[data-live-release]").val("");
      $modal.find("[data-video-status]").val("2");

      $modal
        .find("[data-video-type]")
        .off()
        .on("change", function () {
          if ($(this).val() === "3") {
            $modal.find("[data-meet-link-container]").show();
            $modal.find("[data-meet-release-container]").show();
            $modal.find("[data-video-release-container]").hide();
          } else {
            $modal.find("[data-meet-link-container]").hide();
            $modal.find("[data-meet-release-container]").hide();
            $modal.find("[data-video-release-container]").show();
          }

          if ($(this).val() === "3" || $(this).val() === "4") {
            $modal.find("[data-video-course-container]").show();
          } else {
            $modal.find("[data-video-course-container]").hide();
          }

          if ($(this).val() === "2" || $(this).val() === "4") {
            $modal.find("[data-video-file-container]").show();
          } else {
            $modal.find("[data-video-file-container]").hide();
          }
        });

      $modal.find("[data-meet-link-container]").hide();
      $modal.find("[data-meet-release-container]").hide();
      $modal.find("[data-video-release-container]").show();
      $modal.find("[data-video-course-container]").hide();
      $modal.find("[data-video-file-container]").hide();

      this.showModal(
        $modal,
        function () {
          $modal.find("[data-video-title]").focus();
        },
        "Salvar",
        action,
        "Aula/mentoria adicionada!",
        "Ocorreu um erro adicionar a aula/mentoria.\nPor favor, tente novamente."
      );
    },
  },
};
</script>
